import { atomFamily } from 'recoil';
import { SingleColumnState } from '../../contexts/TableColumnContext';
import { loadPersistedValue, persistOnSet } from '../effects';

export const columnState = atomFamily<SingleColumnState[], string>({
  key: 'columnState',
  default: _recordType => [],
  effects: _recordType => [loadPersistedValue, persistOnSet],
});
